function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import f, { createContext as m, useCallback as D, useContext as P, useMemo as p, useState as T } from "react";
import { useId as g } from "../../hooks/use-id.js";
import { forwardRefWithAs as x, render as h } from "../../utils/render.js";
import { useIsoMorphicEffect as E } from "../../hooks/use-iso-morphic-effect.js";
import { useSyncRefs as S } from "../../hooks/use-sync-refs.js";
var d = /*#__PURE__*/m(null);

function u() {
  var r = P(d);

  if (r === null) {
    var t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, u), t;
  }

  return r;
}

function M() {
  var _T = T([]),
      _T2 = _slicedToArray(_T, 2),
      r = _T2[0],
      t = _T2[1];

  return [r.length > 0 ? r.join(" ") : void 0, p(function () {
    return function (e) {
      var i = D(function (o) {
        return t(function (n) {
          return [].concat(_toConsumableArray(n), [o]);
        }), function () {
          return t(function (n) {
            var a = n.slice(),
                l = a.indexOf(o);
            return l !== -1 && a.splice(l, 1), a;
          });
        };
      }, []),
          s = p(function () {
        return {
          register: i,
          slot: e.slot,
          name: e.name,
          props: e.props
        };
      }, [i, e.slot, e.name, e.props]);
      return /*#__PURE__*/f.createElement(d.Provider, {
        value: s
      }, e.children);
    };
  }, [t])];
}

var v = "p",
    O = x(function (t, c) {
  var e = u(),
      i = "headlessui-description-".concat(g()),
      s = S(c);
  E(function () {
    return e.register(i);
  }, [i, e.register]);

  var o = t,
      n = _objectSpread(_objectSpread({
    ref: s
  }, e.props), {}, {
    id: i
  });

  return h({
    ourProps: n,
    theirProps: o,
    slot: e.slot || {},
    defaultTag: v,
    name: e.name || "Description"
  });
});
export { O as Description, M as useDescriptions };